import { Space } from '@sravni/react-design-system';
import { Heading, Text } from '@sravni/react-design-system/lib/Typography';

import { AdaptiveCard } from '../../AdaptiveCard';

import styles from './FeatureCard.module.scss';

interface IFeatureCardProps {
  image: string;
  title: string;
  subtitle: string;
}

export const FeatureCard = ({ image, title, subtitle }: IFeatureCardProps) => (
  <AdaptiveCard
    className={styles.card}
    desktopSize={24}
    color="light"
  >
    <Space
      size={12}
      direction="vertical"
    >
      <img
        className={styles.img}
        src={image}
        width={80}
        height={80}
        alt="feature card"
      />
      <Heading
        className={styles.title}
        level={5}
      >
        {title}
      </Heading>
      <Text className="h-color-D60">{subtitle}</Text>
    </Space>
  </AdaptiveCard>
);
